import { ExclamationIcon } from "@heroicons/react/solid";

type TextMap = {
  [key: string]: string;
};

const invalidTextMap: TextMap = {
  text: "Value is required.",
  email: "Must be a valid email.",
  password: "Must be at least 7 characters.",
};

export default function TextInput({
  id,
  label,
  autoComplete,
  type,
  value,
  onChange,
  required,
}: {
  id: string;
  label: string;
  autoComplete: string;
  type: string;
  value: string;
  onChange: (value: string) => void;
  required: boolean;
}) {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <div className="mt-1">
        <input
          id={id}
          name={id}
          type={type}
          autoComplete={autoComplete}
          className="peer shadow-sm block w-full px-5 pt-2 pb-2.5 sm:text-sm rounded-md bg-white border border-solid border-gray-300 focus:border-vendrive-500 focus:ring-vendrive-500 text-neutral-900 required:invalid:border-red-base required:invalid:focus:border-red-base"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          pattern={type === "password" ? ".{7,}" : undefined}
        ></input>
      </div>
      <div className="hidden peer-required:peer-invalid:flex mt-4 ml-6 items-center">
        <ExclamationIcon className="text-red-base h-5 w-5 mr-2.5"></ExclamationIcon>
        <p className="text-red-base text-sm ">{invalidTextMap[type]}</p>
      </div>
    </div>
  );
}
